export default "__VITE_ASSET__bd700003__"